"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ = require("./..");

var _Form = require("../Form");

var CheckboxField = function CheckboxField(props) {
  return /*#__PURE__*/_react.default.createElement(_.FieldWrapper, (0, _extends2.default)({}, props, {
    fieldType: "Checkbox",
    Field: _.CheckboxInput
  }));
};

CheckboxField.propTypes = (0, _extends2.default)({}, _.CheckboxInput.propTypes, _.FieldWrapper.propTypes);
CheckboxField.displayName = 'CheckboxField';

var _default = (0, _Form.formalizer)(CheckboxField);

exports.default = _default;